import requester from '@/utils/request'
export const baseService: any = {
  // 首页 查询不同类型drops列表
  dropsQuery: (data: any) => requester.post('/drops/v1/page/query', data),
  // 首页 运营位增加合约展示
  dropsPageList: (data: any) => requester.post('/drops/v1/page/list', data),
  postQuery: (data: any) => requester.post('/blog/v1/home/query', data),
  postQuery2: (data: any) => requester.post('/blog/v2/home/query', data),
  // home 推荐 post 列表
  recommend: (data: any) => requester.post('/blog/v1/recommend/query', data),
  searchPost: (data: any) => requester.post('/blog/v1/searchPost', data),
  // 个人页基本信息
  profileInfo: (data: any, config?: any) => requester.post('/actor/v1/home/profile', data, config),
  // 按照人员活跃排序的drops
  activeQuery: (data: any) => requester.post('/drops/v1/active/query', data),
  // 查询用户购买的nft和collection信息
  commodityNftGroup: (data: any) => requester.post('/nft/commodity/v1/nft/group', data),
  // 查询指定用户持有NFT
  commodityNftGroupByOwner: (data: any) => requester.post('/nft/commodity/v1/page-by-owner', data),
  // 修改用户基础信息
  updateProfile: (data: any) => requester.post('/user/basic/v1/update/profile', data),
  // 修改用户基础信息：公共接口
  commonUpdateProfile: (data: any) => requester.post('/actor/v1/home/profile/update', data),
  // 查看用户所有关注的网红
  followingList: (data: any) => requester.post('/follow/v1/page/following', data),
  // 查看网红拥有的follower
  followerList: (data: any) => requester.post('/follow/v1/page/follower', data),
  fetchFollowerList: (data: any) => requester.post('/follow/follower/list', data),
  trendingCollector: (data: any) => requester.get('/trending/collector', data),
  trendingCreator: (data: any) => requester.get('/trending/creator', data),
  // 判断当前用户是否follow网红
  followCheck: (data: any) => requester.post('/follow/v1/check', data),
  // 关注-取消关注
  followOperate: (data: any) => requester.post('/follow/v1/operate', data),
  // i owned
  commodityQuery: (data: any) => requester.post('/nft/commodity/v2/commodity/page/query', data),
  // post tag query
  getTagList: (data: any) => requester.get('/tag/v1/list', data),
  // 查看用户的积分（累计积分和可用积分）
  queryUserScore: () => requester.get('/score/v1/queryUserScore', {}),
  // 查看任务的积分领取历史记录
  queryScoreHistory: (data: any) => requester.post('/score/v1/queryScoreHistory', data),
  // 领取邀请列表
  queryInviteeList: (data: any) => requester.get('/score/v1/queryInviteeList', data),
  // 判断是否有可领取的积分
  checkCanCollectScore: (data: any) => requester.post('/score/v1/checkCanCollectScore', data),
  // claimScore 领取积分
  claimScore: (data: any) => requester.post('/score/v1/claimScore', data),
  // 返回任务类型列表（包括每种类型当天的领取状态）
  queryTaskTypeList: () => requester.get('/score/v1/queryTaskTypeList', {}),
  // 查看积分排行榜
  queryPointRanking: (data: any) => requester.post('/score/v1/ranking', data),
  // 查询第一个可购买drop
  activeFirst: () => requester.get('/drops/v1/active/first', {}),
  // 用户点击推荐合约分享url
  clickShareLink: (data: any) => requester.post('/score/v1/clickShareLink', data),
  // 美金购买积分
  legalCurrency: (data: any) => requester.post('/score/v1/buy/by/legal-currency', data),
  // 积分解锁
  unlockByPoint: (data: any) => requester.post('/score-unlock-album/post/unlock', data),
  // 查询购买积分档级种类
  buyLevel: () => requester.get('/score/v1/buy/level', {}),
  // 根据条件获取创作者信息 顶部导航栏搜索
  creatorSearch: (data: any) => requester.post('/actor/v1/creator/list/by-param', data),
  // 获取用户投资的创作者信息（包括投资的金额）
  queryInvestCreator: (data: any) => requester.post('/invest/v1/queryInvestCreator', data),
  // 查询指定用户持有投资合约NFT
  queryInvestmentByOwner: (data: any) =>
    requester.post('/nft/commodity/v1/investment/page-by-owner', data),
  // 用户申请成为创作者
  applyCreate: (data: any) => requester.post('/creator/submission/v1/submit', data),
  // 域名校验
  verifyDomain: (data: any) => requester.post('/shop/v1/domain/exist', data),
  // 查询用户申请状态
  queryApplyCreate: (address: string) =>
    requester.post('/creator/submission/v1/detail', { address }),
  // 查询我的购买记录
  queryPurchaseHistory: (data: any) =>
    requester.get('/wallet/transaction/v1/purchase-history', data),
  // 首页 判断是否需要弹框
  //  queryIsPopUp: (data: any) => requester.get('/common/global-pop-up/isPopUp',data),
  // 首页获取全局弹框配置
  getGlobalPopUp: () => requester.get('/common/global-pop-up/getGlobalPopUp'),
  // 首页 弹框后回调
  triggerPopUp: (data: any) => requester.post('/common/global-pop-up/triggerPopUp', data),
  // 查询当期奖池
  getCurrentPrizePool: (data: any) => requester.post('/nft/prize-revenue/currentPrizePool', data),
  // 查询当期开奖历史记录
  getPrizeHistory: (data: any) => requester.post('/nft/prize-revenue/getPrizeHistory', data),
  // 查询往期开奖历史记录
  getSimpleHistory: (data: any) => requester.post('/nft/prize-revenue/getSimpleHistory', data),
  // 查询某期开奖详情
  getPrizeDetailOfWeek: (data: any) =>
    requester.post('/nft/prize-revenue/getPrizeDetailOfWeek', data),
  // 查询banner
  getBanner: (data: any) => requester.post('/common/banner-config/list', data),
  // 绑定邮箱
  bindEmail: (data: any) => requester.post('/dfans/bind-email', data),
  // 粉丝删除账号
  deleteAccount: (data: any) => requester.post('/user/common/v1/deleteAccount', data),
  // 创作者删除账号
  deleteAccountCreator: (data: any) => requester.post('/common/creator/deleteAccount', data),
  // 发送安全验证码到用户邮箱
  sendSecurityCode: (data: any) => requester.post('/user/common/sendSecurityCode', data),
  // 发送安全验证码到用户邮箱
  refreshToken: (data: any) => requester.post('/dfans/v1/refresh-token', data),
  // 重置密码
  resetPassword: (data: any) => requester.post('/dfans/v1/password/reset', data),
  // 重置密码-发送邮件
  resetPasswordBySendEmail: (data: any) =>
    requester.post('/dfans/v1/password/reset/send-mail', data),
  // 修改密码
  updatePassword: (data: any) => requester.post('/dfans/v1/password/update', data),
  // 验证邮箱
  validEmail: (data: any) => requester.post('/dfans/v1/lunch/valid-email', data),
  // 更新电子邮件：向旧邮箱发送验证码
  sendOldEmailCode: () => requester.post('/dfans/v1/email/update/send/old/verification-code', {}),
  // 更新电子邮件：验证旧邮箱验证码
  checkOldEmailCode: (data: any) => requester.post('/dfans/v1/email/update/check-code', data),
  // 更新电子邮件：向新邮箱发送验证码
  sendNewEmailCode: (data: any) =>
    requester.post('/dfans/v1/email/update/send/new/verification-code', data),
  // 更新电子邮件
  updateNewEmail: (data: any) => requester.post('/dfans/v1/email/update', data),
  // 重置密码 -- 验证邮件链接
  verifyResetPasswordCode: (verificationCode: string) =>
    requester.post(`/dfans/v1/password/reset/check/${verificationCode}`),
  // 验证邮箱 -- 验证邮箱链接
  validEmailToken: (data: any) => requester.post('/dfans/v1/valid-email', data),
  // 根据邮箱地址获取登录随机数
  getEmailNonce: (data: any) => requester.post('/dfans/v1/email/nonce', data),
  // 获取google recaptcha 评分
  getGoogleRecaptcha: (data: any) => requester.post('/dfans/recaptcha/score', data),
  // block用户
  blockUser: (data: any) => requester.post('/common/creator/blockUser', data),
  // unblock用户
  unBlockUser: (data: any) => requester.post('/common/creator/unBlockUser', data),
  // 查看block-restrict用户列表
  blockUserList: (data: any) => requester.post('/common/creator/queryBlockUserList', data),
  // 预认证
  preAccess: (data: any) => requester.post('/rate/limit/pre-access', data),
  // 认证
  access: (data: any) => requester.post('/rate/limit/access', data),
}
